/* eslint-disable react/react-in-jsx-scope */
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonMenuButton,
  IonTitle,
  IonContent,
} from "@ionic/react";
import { useEffect } from "react";
import { getToken } from "../utils/utils";

const ddPage: React.FC = () => {
  const token = getToken();

  //   useEffect(() => {});

  return (
    <IonPage id="ddPage">
      <IonHeader>
        <IonToolbar className="customBg">
          <IonButtons slot="start">
            <IonMenuButton className="txtW" />
          </IonButtons>
          <IonTitle>
            <strong className="txtW">Super Admin - Deposito Dental</strong>
          </IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen className="cIframe">
        <h3 className="customTxt">En Construcción</h3>
        {/* <iframe src="http://consultorio.elfuerte.online/"></iframe> */}
      </IonContent>
    </IonPage>
  );
};

export default ddPage;
